import styled, { css } from 'styled-components';

const AvatarWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  transition: all 0.1s ease;
  cursor: default;
  ${(props) =>
    !!props.active &&
    css`
      cursor: pointer;
    `};
  ${(props) =>
    !!props.withBorderLeft &&
    css`
      border-left: 3px solid white;
    `};
`;

export default AvatarWrapper;
